function applyEventListeners(wrapper) {
  const display = wrapper.querySelector('.select-current');
  const options = wrapper.querySelector('.select-options');
  const overlay = wrapper.querySelector('.select-options-overlay');
  const links = wrapper.querySelectorAll('a');

  [display, overlay, ...links].forEach((el) => {
    if (el) {
      el.addEventListener('click', () => {
        options.classList.toggle('hidden');
        overlay.classList.toggle('hidden');
      });
    }
  });
}

const initalizeBuyerSellerDropdown = () => {
  const selectWrappers = document.getElementsByClassName('select-wrapper');
  if (selectWrappers) {
    for (let i = 0; i < selectWrappers.length; i += 1) {
      applyEventListeners(selectWrappers[i]);
    }
  }
};

export default initalizeBuyerSellerDropdown;
